import { loadCacheFromLocalStorage } from '../../../helpers/localStorage';
import { ALL_COLUMNS, CACHE_KEY } from '../constants';
// Every browser that opened this page before the Priority rename has 'risk' in
// its cached columns. Map it forward instead of just dropping it, or the
// column silently disappears for every existing user until they re-enable it.
const LEGACY_COLUMN_IDS = { risk: 'priority' };
export const INITIAL_FILTERS = {
    values: {
        account: '',
        building: '',
        technician: null,
        technicianTeam: '',
        status: '',
        frequency: '',
        territory: '',
        buildingStatus: '',
        subcontractor: '',
        inspectionType: '',
        noAccess: '',
        zipCode: '',
        referenceNumber: '',
        workOrder: '',
        tags: '',
        tce: '',
        tceErrors: '',
        irol: '',
        irolErrors: '',
        livsafe: '',
        livsafeErrors: '',
        asset: '',
        inspectionSeries: '',
        inspectionId: '',
        iimReviewStatus: '',
        scheduledDate: {
            rangeType: 'custom_range',
            startDate: '',
            endDate: '',
            fieldType: 'dateRange'
        },
        inspectionDate: {
            rangeType: 'custom_range',
            startDate: '',
            endDate: '',
            fieldType: 'dateRange'
        }
    },
    active: {
        account: false,
        building: true,
        technician: true,
        technicianTeam: false,
        status: true,
        frequency: true,
        territory: false,
        buildingStatus: false,
        subcontractor: false,
        inspectionType: false,
        noAccess: false,
        zipCode: false,
        referenceNumber: false,
        workOrder: false,
        tags: false,
        tce: false,
        tceErrors: false,
        irol: false,
        irolErrors: false,
        livsafe: false,
        livsafeErrors: false,
        asset: true,
        scheduledDate: true,
        inspectionDate: false,
        dueDate: false,
        inspectionSeries: false,
        inspectionId: false,
        iimReviewStatus: false
    },
    operators: {
        zipCode: 'contains',
        referenceNumber: 'contains',
        workOrder: 'contains',
        inspectionId: 'contains'
    }
};
export const getInitialData = ({ cacheKey }) => {
    var _a;
    const cache = loadCacheFromLocalStorage(cacheKey || CACHE_KEY) || {};
    return {
        page: cache.page || { skip: 0, take: 25 },
        sort: cache.sort || [{ field: 'iimReviewStatus', dir: 'asc' }],
        filters: cache.filters || INITIAL_FILTERS,
        columns: ((_a = cache.columns) === null || _a === void 0 ? void 0 : _a.map((column) => { var _a; return (_a = LEGACY_COLUMN_IDS[column]) !== null && _a !== void 0 ? _a : column; }).filter((column) => ALL_COLUMNS.includes(column))) || ALL_COLUMNS,
        data: [],
        totalCount: 0,
        loading: false,
        cacheKey: cacheKey || CACHE_KEY
    };
};
